import ListCalculatePhases from './views/List.vue'
import CreateCalculatePhase from './views/CreateEdit.vue'
import GetCalculatePhase from './views/Get.vue'

export const CalculatePhasesRoutes = [
  {
    path: '/calculate-phases',
    name: 'ListCalculatePhases',
    component: ListCalculatePhases,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'phase:list'
    }
  },
  {
    path: '/calculate-phase',
    name: 'CreateCalculatePhase',
    component: CreateCalculatePhase,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'phase:create'
    }
  },
  {
    path: '/calculate-phase/:id',
    name: 'UpdateCalculatePhase',
    component: CreateCalculatePhase,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'phase:update'
    }
  },
  {
    path: '/calculate-phase/view/:id',
    name: 'GetCalculatePhase',
    component: GetCalculatePhase,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'phase:get'
    }
  }
]
